// Module
var code = "<span>{{$ctrl.getCountryNameByCode($ctrl.code)}}</span> ";
// Exports
module.exports = code;